import { theme as antTheme } from 'antd';
const sharedToken = {
    colorPrimary: '#ffae43',
    colorLink: '#ffae43',
    colorPrimaryHover: '#ffbb62',
    colorPrimaryActive: 'var(--ant-color-primary-hover)',
    colorPrimaryTextActive: 'var(--ant-color-primary-hover)',
    colorLinkHover: 'var(--ant-color-primary-hover)',
    colorLinkActive: 'var(--ant-color-primary-hover)',
    colorPrimaryBorder: '#ffdaa9',
    colorPrimaryBorderHover: '#ffcf8f',
    colorInfo: '#90d7ff',
    colorInfoHover: '#b9e6ff',
    colorInfoActive: 'var(--ant-color-info-hover)',
    colorInfoTextActive: 'var(--ant-color-info-hover)',
    colorSuccess: '#9bd920',
    colorSuccessActive: '#d0f272',
    colorSuccessTextActive: 'var(--ant-color-success-active)',
    colorWarning: '#FFCA00',
    colorWarningActive: '#FFE852',
    colorWarningTextActive: 'var(--ant-color-warning-active)',
    colorError: '#ff7d4b',
    colorErrorActive: '#ff9f73',
    colorErrorTextActive: 'var(--ant-color-error-active)',
    fontFamily: "'Open Sans', sans-serif",
    fontSize: 15,
    fontSizeSM: 14,
    fontSizeLG: 17,
    fontSizeHeading1: 23,
    fontSizeHeading2: 18,
    fontSizeHeading3: 16,
    fontSizeHeading4: 15,
    fontWeightStrong: 600,
    borderRadius: 16,
    borderRadiusSM: 4,
    borderRadiusLG: 20,
    boxShadow: '0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)',
    marginXXS: 0,
};
const lightToken = {
    ...sharedToken,
    colorInfoBg: '#f1faff',
    colorTextBase: '#444444',
    colorText: 'var(--ant-color-text-base)',
    colorTextSecondary: '#666666',
    colorTextDisabled: '#bababa',
    colorTextDescription: 'var(--ant-color-text-disabled)',
    colorIcon: 'var(--ant-color-text-base)',
    colorBorder: '#D9D9D9',
    colorBgContainerDisabled: '#eeeeee',
    colorFillTertiary: '#f6f6f6',
};
const darkToken = {
    ...sharedToken,
    colorInfoBg: '#152028',
    colorTextBase: '#e8e4df',
    colorText: 'var(--ant-color-text-base)',
    colorTextSecondary: '#b0aaa3',
    colorTextDisabled: '#6e6862',
    colorTextDescription: 'var(--ant-color-text-disabled)',
    colorIcon: 'var(--ant-color-text-base)',
    colorBorder: '#3d3832',
    colorBgContainerDisabled: '#2a2622',
    colorFillTertiary: '#2a2622',
};
const sharedComponents = {
    Button: {
        borderRadiusSM: 40,
        borderRadius: 40,
        borderColorDisabled: 'transparent',
        colorLink: 'var(--ant-color-primary)',
        colorLinkHover: 'var(--ant-color-primary-hover)',
    },
    Modal: {
        titleFontSize: 17,
        contentPadding: '16px 30px',
    },
    Menu: {
        itemHoverBg: 'transparent',
        itemActiveBg: 'transparent',
        itemBg: 'transparent',
        itemMarginInline: 0,
        subMenuItemBg: 'transparent',
        activeBarBorderWidth: 0,
    },
    Table: {
        cellPaddingBlock: 5,
        cellPaddingInline: 5,
        headerColor: 'var(--ant-color-text-base)',
        headerFilterHoverBg: 'transparent',
        headerSplitColor: 'transparent',
        headerBg: 'var(--ant-color-fill-tertiary)',
        rowHoverBg: 'var(--ant-color-info-bg)',
        headerIconColor: 'var(--ant-color-text-secondary)',
    },
    Tag: {
        colorBorder: 'transparent',
        borderRadiusSM: 40,
    },
    Card: {
        paddingLg: '24px',
    },
    Badge: {
        colorError: 'var(--ant-color-info)',
        colorErrorHover: 'var(--ant-color-info-hover)',
    },
    Progress: {
        defaultColor: 'var(--ant-color-info)',
    },
    Switch: {
        colorPrimary: 'var(--ant-color-info)',
        colorPrimaryBorder: 'var(--ant-color-info)',
        colorPrimaryHover: 'var(--ant-color-info-hover)',
    },
    Radio: {
        radioBgColor: 'var(--ant-color-primary)',
        buttonSolidCheckedHoverBg: 'var(--ant-color-primary-hover)',
        buttonSolidCheckedBg: 'var(--ant-color-primary)',
    },
    Slider: {
        trackBg: 'var(--ant-color-info)',
        handleActiveColor: 'var(--ant-color-info-hover)',
        handleColor: 'var(--ant-color-info)',
        dotActiveBorderColor: 'var(--ant-color-info-hover)',
        colorPrimaryBorderHover: 'var(--ant-color-info-hover)',
    },
    Alert: {
        colorErrorBorder: 'transparent',
        colorSuccessBorder: 'transparent',
        colorInfoBorder: 'transparent',
        colorWarningBorder: 'transparent',
    },
    Form: {
        itemMarginBottom: 15,
        labelFontSize: 15,
        verticalLabelPadding: 4,
    },
    Select: {
        borderRadiusSM: 14,
    },
    Upload: {
        actionsColor: 'var(--ant-color-icon)',
    },
};
export const createAntTheme = (mode) => {
    const isDark = mode === 'dark';
    return {
        cssVar: true,
        algorithm: isDark ? antTheme.darkAlgorithm : antTheme.defaultAlgorithm,
        token: isDark ? darkToken : lightToken,
        components: {
            ...sharedComponents,
            Layout: {
                siderBg: 'transparent',
                bodyBg: isDark
                    ? 'linear-gradient(180deg, #1d1d1d 0%, #282828 100%)'
                    : 'linear-gradient(180deg, #fdfaf6 0%, #f7f0e4 56%, #ffe9cb 100%)',
                headerBg: 'transparent',
                headerPadding: '0 20px',
                headerColor: 'var(--ant-color-text-base)',
                footerBg: 'transparent',
            },
            Collapse: {
                headerPadding: 0,
                contentPadding: 0,
            },
        },
    };
};
/** Light baseline for public SubtitlesPage and root ConfigProvider */
export const theme = createAntTheme('light');
